<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Service Names'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Customize how service names appear to you. This helps you identify services more easily in your schedule, checklists, and reports.'" />
      </tidy-row>

      @if (errorMessage) {
        <tidy-alert>
          <tidy-text [body]="errorMessage" />
        </tidy-alert>
      }

      @if (services && services.length > 0) {
        <tidy-card>
          <ion-row>
            <ion-col style="flex: 1;">
              <tidy-text [header]="'Original Name'" />
            </ion-col>
            <ion-col style="flex: 1;">
              <tidy-text [header]="'Your Name (Optional)'" />
            </ion-col>
          </ion-row>
        </tidy-card>

        <form [formGroup]="form">
          @for (service of services; track service.id) {
            <tidy-card>
              <ion-row>
                <ion-col style="flex: 1; display: flex; align-items: center;">
                  <tidy-text
                    [body]="service.originalName" />
                </ion-col>
                <ion-col style="flex: 1;">
                  <tidy-input
                    [icon]="'assets/svg/create.svg'"
                    [formControlName]="'service_' + service.id"
                    [form]="form.get('service_' + service.id)"
                    [placeholder]="'Enter custom name (optional)'" />
                </ion-col>
                <ion-col size="auto">
                  <tidy-button
                    [text]="'Save'"
                    [action]="getUpdateServiceNameAction(service.id)"
                    class="primary" />
                </ion-col>
              </ion-row>
            </tidy-card>
          }
        </form>

        <tidy-row [align]="'center'" style="margin-top: 20px;">
          <tidy-button
            [text]="'Continue'"
            [action]="boundSave"
            class="primary" />
        </tidy-row>
      } @else {
        <tidy-alert>
          <tidy-text [body]="'No services found.'" />
        </tidy-alert>
      }
    } @else {
      <tidy-loader />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
